// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__16_EH","paramInput":"JobSimulator_paramInput__2QPD_","input":"JobSimulator_input__9EjFp"};